import { Box, Typography, TypographyVariant } from "@mui/material"

export const BalanceIndicator = ({
  formattedBalance,
  baseSize,
  variant,
}: {
  formattedBalance: string
  baseSize: number
  variant: TypographyVariant
}) => {
  const getFontSize = () => {
    let textLength = formattedBalance.length
    if (textLength >= baseSize) {
      textLength = baseSize - 2
    }
    const fontSize = baseSize - textLength
    return fontSize
  }

  return (
    <Box sx={{ width: "100%", textAlign: "center" }}>
      <Typography
        variant={variant}
        sx={{
          fontSize: `${getFontSize()}px`,
        }}
      >
        {formattedBalance} ₽
      </Typography>
    </Box>
  )
}
